import { render, staticRenderFns } from "./BlockedIPsTableRow.vue?vue&type=template&id=5ef1ad50&"
import script from "./BlockedIPsTableRow.vue?vue&type=script&lang=js&"
export * from "./BlockedIPsTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports